module.exports = __webpack_public_path__ + "static/inno4-e1aa8901a2f8d0c147432e4356ae82c3.jpg";